import { API_AUTH_URL } from 'config'
import { apiCall } from './base'

export const changePasswordToken = async (data) => {
  const result = await apiCall(`/api/v1/auth/password/send-token`, {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })
  return result
}

export const loginOTPChangePassword = async (token) => {
  const result = await apiCall(`/api/v1/auth/password/token?otp=${token}`, {
    baseURL: API_AUTH_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
  return result
}

export const changePassword = async (data) => {
  const result = await apiCall(`/api/v1/auth/password/change`, {
    baseURL: API_AUTH_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })
  return result
}